import { ErrorCodeConstants } from './ErrorCodeConstants';
import { StorageHelper } from './StorageHelper';

interface PrevalidacionErrorHandlerProps {
  setMessageError: (message: string) => void;
  setShowError: (show: boolean) => void;
  setTypeError: (type: number) => void;
  setShowDniError: (show: boolean) => void;
  t: (key: string) => string;
}

export default function HandlePrevalidacionError(
  errorCode: number,
  {
    setMessageError,
    setShowError,
    setTypeError,
    setShowDniError,
    t,
  }: PrevalidacionErrorHandlerProps,
) {
  setMessageError(t('tarjetas.tarjeta-socio.error-AME-prevalidation-message'));

  switch (errorCode) {
    case ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION:
      setShowError(true);
      setTypeError(
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION,
      );
      break;

    case ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION:
      setShowError(true);
      setTypeError(
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION,
      );
      break;

    case ErrorCodeConstants.UPDATE_DATOSACCESO_CLIENTEV0_DNI_NO_EDITABLE_SAC:
      setShowDniError(true);
      break;

    case ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION:
      setTypeError(
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION,
      );
      setShowError(true);
      StorageHelper.setModalToUpMisDatos('true');

      break;

    case ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION:
      setTypeError(
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION,
      );
      setShowError(true);
      break;

    default:
      setShowError(false);
  }
}
